export default {
  // selectedMap: localStorage.getItem('selectedMap') ? JSON.parse(localStorage.getItem('selectedMap')) : null,
  maps: localStorage.getItem('maps') ? JSON.parse(localStorage.getItem('maps')) : null,
  searchedMap: null,
  AQIDetail: null,
  date_filter_map:null,
  time_filter_map:null,
  count: 0,
}
